import React, { useState, useEffect, useRef } from "react";
import s from "./FirstStepper.module.css";
import { getAgencieById } from "../../../../../../api/agencies/AgenciesService";
//servicio
import providersService from "../../../../../../api/providers/providersService";
//Assets
import OrdersModal from "../../Steppers/Modales/OrdersModal/OrdersModal";
import ProvidersModal from "../../../../../Shared/ProvidersModal";
import AgencyModal from "../../../../../Shared/AgencyModal";
import AgencyModalByStock from "../../../../../Shared/AgencyModalByStock";
import { today } from "../../../../../../helpers/today";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "dayjs/locale/es";
import "dayjs/locale/pt";
//Material
import Grid from "@mui/material/Grid"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"
import ToggleButton from "@mui/material/ToggleButton"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import InputLabel from "@mui/material/InputLabel"
import CircularProgress from "@mui/material/CircularProgress"
import Input from "@mui/material/Input"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import ordersService from "../../../../../../api/delivery/ordersServices"
import useTranslationException from "../../../../../../helpers/exceptions"

// ============================== | FIRST STEPPER | ===========================

const FirstStepper = ({
  form,
  setForm,
  edit,
  order,
  setOrder,
  destino,
  setDestino,
}) => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const dispatch = useDispatch();

  const { language } = useSelector((state) => state.local);

  //Estados
  const [deliveryEntity, setDeliveryEntity] = useState(null);
  const [orderSelect, setOrderSelect] = useState(null);

  const [providers, setProviders] = useState([]);
  const [transportista, setTransportista] = useState(0);

  const [loadingData, setLoadingData] = useState(false);
  const [open, setOpen] = useState(false);
  const [openOrders, setOpenOrders] = useState(false);
  // Section using reference
  const ref = useRef(false)

  useEffect(() => {
    if (!ref.current) {
      providersService
        .getProviders(1, 100, dispatch)
        .then((res) => setProviders(res.content));
      if (form?.agencyId) {
        setLoadingData(true);
        getAgencieById(form?.agencyId)
          .then((res) => {
            setDeliveryEntity(res);
          })
          .then(() => {
            setDestino("agencia");
            setLoadingData(false);
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("anErrorOccurred,TryAgain"),
              t("sorryErrorOcurred"),
            );
            setLoadingData(false);
          });
      }
      if (form?.supplierId) {
        setLoadingData(true);
        providersService
          .getSupplierById(form?.supplierId)
          .then((res) => {
            setDeliveryEntity(res.content.filter(supplier => supplier.id === form?.supplierId)[0]);
          })
          .then(() => {
            setDestino("proveedor");
            setLoadingData(false);
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("anErrorOccurred,TryAgain"),
              t("sorryErrorOcurred"),
            );
            setLoadingData(false);
          });
      }
      if (form?.orderId) {
        ordersService
          .getOrderById(form?.orderId)
          .then((res) => setOrderSelect(res));
      }

      ref.current = true
    }
  }, [dispatch, form, setDestino, showExpetion, t]);

  useEffect(() => {
    if (deliveryEntity?.id) {
      if (destino === "proveedor") {
        setForm((prev) => ({
          ...prev,
          agencyId: 0,
          agencyName: "",
          supplierId: deliveryEntity.id,
          supplierName: deliveryEntity.businessName,
        }));
      } else {
        setForm((prev) => ({
          ...prev,
          supplierId: 0,
          supplierName: "",
          agencyId: deliveryEntity.id,
          agencyName: `${deliveryEntity.name} (${deliveryEntity.number}${deliveryEntity.subNumber ? ` - ${deliveryEntity.subNumber}` : ""})`,
        }));
      }
    } else {
      setForm((prev) => ({
        ...prev,
        supplierId: 0,
        supplierName: "",
        agencyId: 0,
        agencyName: "",
      }));
    }
  }, [deliveryEntity, destino, setForm]);

  useEffect(() => {
    setOrder(orderSelect);
  }, [orderSelect, setOrder]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Grid item container xs={12} className={s.container}>
      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        className={s.init2}
      >
        <h4
          style={{
            fontSize: "1.6rem",
            fontWeight: 300,
            margin: 0,
            marginTop: "10px",
          }}
        >
          {t("deliveryNoteHead")}
        </h4>
      </Grid>
      <Grid
        item
        container
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 5,
        }}
        className={s.init1}
      >
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            mt: 3,
          }}
        >
          <p
            style={{ marginRight: "10px", fontSize: "1.2rem", fontWeight: 400 }}
          >
            {t("type")}:
          </p>
          <ToggleButtonGroup
            size="small"
            color="primary"
            value={form.type}
            disabled={edit.status}
            exclusive
            onChange={(e) => handleChange(e)}
          >
            <ToggleButton value="Entrada" name="type">
              {t("entrance")}
            </ToggleButton>
            <ToggleButton value="Salida" name="type">
              {t("exit")}
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid
          item
          lg={6}
          md={6}
          xs={11}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            mt: 3,
          }}
        >
          <p style={{ fontSize: "1.2rem", marginRight: "10px" }}>
            {t("state")}:
          </p>
          <p style={{ fontSize: "1.5rem", fontWeight: 300 }}>{form.state}</p>
        </Grid>
        {form.type === "Salida" ? (
          <Grid item lg={6} xs={11} sx={{ mt: 3 }} className={s.init1}>
            <InputLabel htmlFor="output-input">
              {t("deliveryNoteNumber")}
            </InputLabel>
            <Input
              disabled
              id="output-input"
              type="text"
              name="nroOutput"
              value={form.nroOutput}
              sx={{ width: "95%" }}
            />
          </Grid>
        ) : (
          <Grid item lg={6} xs={11} sx={{ mt: 3 }} className={s.init1}>
            <TextField
              inputProps={{ maxLength: 9 }}
              name="nroInput"
              value={form.nroInput}
              label={t("deliveryNoteNumber")}
              sx={{ width: "95%" }}
              onChange={(e) => {
                if (!isNaN(e.target.value) && Number(e.target.value) >= 0) {
                  handleChange(e);
                }
              }}
              onKeyPress={(e) => {
                if (e?.key === "-" || e?.key === "+") {
                  e.preventDefault();
                }
              }}
            />
          </Grid>
        )}
        <Grid item lg={6} xs={11} sx={{ mt: 3 }} className={s.init1}>
          <TextField
            label={`${t("lotery")} ${form.type === "Salida" ? t("shipperAddress") : t("destinationAddress")}`}
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            value={form.lotteryName}
            sx={{ width: "95%" }}
          />
        </Grid>
        <Grid item lg={6} xs={11} sx={{ mt: 3 }} className={s.init1}>
          <FormControl sx={{ width: "95%" }}>
            <InputLabel id="select-label-provider">
              {`${t("type")} ${form.type === "Salida" ? t("destinationAddress") : t("shipperAddress")}`}
            </InputLabel>
            <Select
              labelId="select-label-provider"
              value={destino}
              label={`${t("type")} ${form.type === "Salida" ? t("destinationAddress") : t("shipperAddress")}`}
              onChange={(e) => {
                setDestino(e.target.value);
                setDeliveryEntity(null);
              }}
            >
              <MenuItem value={"proveedor"}>{t("provider")}</MenuItem>
              <MenuItem value={"agencia"}>{t("agency")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          lg={6}
          xs={11}
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {loadingData ? (
            <CircularProgress size="2rem" />
          ) : (
            <>
              <TextField
                value={
                  deliveryEntity
                    ? destino === "proveedor"
                      ? `${deliveryEntity.businessName}`
                      : `${deliveryEntity.name} (${deliveryEntity.number}${deliveryEntity.subNumber ? ` - ${deliveryEntity.subNumber}` : ""})`
                    : `${t("select")} ${form.type === "Salida" ? t("destinationAddress").toLowerCase() : t("shipperAddress").toLowerCase()}`
                }
                InputProps={{ readOnly: true }}
                label={
                  form.type === "Salida"
                    ? t("destinationAddress")
                    : t("shipperAddress")
                }
                sx={{ width: "70%" }}
              />
              <Button
                sx={{ ml: 3 }}
                variant="contained"
                onClick={() => setOpen(true)}
              >
                {t("find")}
              </Button>
            </>
          )}
        </Grid>
        {form.type !== "Salida" ? (
          form.type !== "Entrada" && destino === "proveedor" ? ( // WARNING: The intention of this line is not render the origin input
            <Grid
              item
              lg={6}
              xs={11}
              sx={{
                mt: 3,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <TextField
                value={
                  orderSelect?.id
                    ? `${t("purchaseOrder")}: ${orderSelect?.id.toString().padStart(5, "0")}`
                    : t("purchaseOrder")
                }
                InputProps={{ readOnly: true }}
                sx={{ width: "70%" }}
              />
              <Button
                sx={{ ml: 3 }}
                variant="contained"
                onClick={() => setOpenOrders(true)}
              >
                {t("find")}
              </Button>
            </Grid>
          ) : null
        ) : (
          <Grid
            item
            lg={6}
            xs={11}
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <FormControl sx={{ width: "95%" }}>
              <InputLabel id="select-label-provider">
                {"Transportista"}
              </InputLabel>
              <Select
                labelId="select-label-provider"
                label="Transportista"
                value={form?.carrierId === null ? 0 : form?.carrierId}
                onChange={(e) =>
                  setForm((prev) => ({ ...prev, carrierId: e.target.value }))
                }
              >
                <MenuItem value={0}>{t("select")}</MenuItem>
                {providers?.map((p, i) =>
                  p.typeSupplier.includes("Transportista") ? (
                    <MenuItem key={i} value={p.id}>
                      {p.businessName}
                    </MenuItem>
                  ) : null,
                )}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid
          item
          lg={6}
          xs={11}
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={language}
          >
            <DatePicker
              label={t("date")}
              autoOk
              minDate={form.type === "Salida" ? today() : false}
              inputFormat="DD/MM/YYYY"
              inputProps={{
                readOnly: true,
              }}
              value={form.date}
              onChange={(e) =>
                setForm({ ...form, date: new Date(e.toLocaleString()) })
              }
              renderInput={(params) => (
                <TextField {...params} sx={{ width: "95%" }} />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid
          item
          lg={12}
          xs={11}
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <TextField
            name="observations"
            onChange={(e) => handleChange(e)}
            value={form.observations}
            label={t("observations")}
            sx={{ width: "98%" }}
            multiline
            rows={6}
          />
        </Grid>
      </Grid>

      {open ? (
        destino === "proveedor" ? (
          <ProvidersModal
            open={open}
            setOpen={setOpen}
            selectProvider={setDeliveryEntity}
            type={form.type}
          />
        ) : form.type === "Entrada" ? (
          <AgencyModalByStock
            open={open}
            setOpen={setOpen}
            selectAgency={setDeliveryEntity}
          />
        ) : (
          <AgencyModal
            open={open}
            setOpen={setOpen}
            selectAgency={setDeliveryEntity}
            type={form.type}
          />
        )
      ) : null}
      {openOrders ? (
        <OrdersModal
          open={openOrders}
          setOpen={setOpenOrders}
          setOrderSelect={setOrderSelect}
          form={form}
          setForm={setForm}
        />
      ) : null}
    </Grid>
  );
};

export default FirstStepper;
